import _ from "lodash"
export default function setSeoData(frontmatter) {
  let seo_data = {}
  if (frontmatter.meta && _.isObject(frontmatter.meta)) {
    seo_data = frontmatter.meta
  }
  if (frontmatter.name) {
    seo_data.name = frontmatter.name
  }
  if (frontmatter.title) {
    seo_data.name = frontmatter.title
  }
  return seo_data
}
